import * as React from 'react';

import {ChartType, ValueRepresentationType} from 'common/report/constants';
import {AnalysisType, ChartPlotStyle, DisplayOptions} from 'common/report/insights/util/types';

import {CardSnabbdom} from '../chart-card';

const SERIES = [
  {
    '2023-10-20T00:00:00-07:00': 271985,
    '2023-10-21T00:00:00-07:00': 89242,
    '2023-10-22T00:00:00-07:00': 138173,
    '2023-10-23T00:00:00-07:00': 352554,
    '2023-10-24T00:00:00-07:00': 353474,
    '2023-10-25T00:00:00-07:00': 373951,
    '2023-10-26T00:00:00-07:00': 364460,
    '2023-10-27T00:00:00-07:00': 266966,
    '2023-10-28T00:00:00-07:00': 89233,
    '2023-10-29T00:00:00-07:00': 146972,
    '2023-10-30T00:00:00-07:00': 394414,
    '2023-10-31T00:00:00-07:00': 370678,
    '2023-11-01T00:00:00-07:00': 349253,
    '2023-11-02T00:00:00-07:00': 355518,
    '2023-11-03T00:00:00-07:00': 270360,
    '2023-11-04T00:00:00-07:00': 83408,
    '2023-11-05T00:00:00-07:00': 164081,
    '2023-11-06T00:00:00-08:00': 385160,
    '2023-11-07T00:00:00-08:00': 376385,
    '2023-11-08T00:00:00-08:00': 364837,
    '2023-11-09T00:00:00-08:00': 348343,
    '2023-11-10T00:00:00-08:00': 229694,
    '2023-11-11T00:00:00-08:00': 78462,
    '2023-11-12T00:00:00-08:00': 136906,
    '2023-11-13T00:00:00-08:00': 350388,
    '2023-11-14T00:00:00-08:00': 363911,
    '2023-11-15T00:00:00-08:00': 365971,
    '2023-11-16T00:00:00-08:00': 358557,
    '2023-11-17T00:00:00-08:00': 255458,
    '2023-11-18T00:00:00-08:00': 84245,
    '2023-11-19T00:00:00-08:00': 31743,
  },
  {
    '2023-10-20T00:00:00-07:00': 54876,
    '2023-10-21T00:00:00-07:00': 8670,
    '2023-10-22T00:00:00-07:00': 22101,
    '2023-10-23T00:00:00-07:00': 77198,
    '2023-10-24T00:00:00-07:00': 74232,
    '2023-10-25T00:00:00-07:00': 82914,
    '2023-10-26T00:00:00-07:00': 80660,
    '2023-10-27T00:00:00-07:00': 53503,
    '2023-10-28T00:00:00-07:00': 8678,
    '2023-10-29T00:00:00-07:00': 23566,
    '2023-10-30T00:00:00-07:00': 85246,
    '2023-10-31T00:00:00-07:00': 84049,
    '2023-11-01T00:00:00-07:00': 77008,
    '2023-11-02T00:00:00-07:00': 79836,
    '2023-11-03T00:00:00-07:00': 54140,
    '2023-11-04T00:00:00-07:00': 8347,
    '2023-11-05T00:00:00-07:00': 30776,
    '2023-11-06T00:00:00-08:00': 87278,
    '2023-11-07T00:00:00-08:00': 86837,
    '2023-11-08T00:00:00-08:00': 84955,
    '2023-11-09T00:00:00-08:00': 77993,
    '2023-11-10T00:00:00-08:00': 46115,
    '2023-11-11T00:00:00-08:00': 8419,
    '2023-11-12T00:00:00-08:00': 23253,
    '2023-11-13T00:00:00-08:00': 76776,
    '2023-11-14T00:00:00-08:00': 84670,
    '2023-11-15T00:00:00-08:00': 78092,
    '2023-11-16T00:00:00-08:00': 79626,
    '2023-11-17T00:00:00-08:00': 52997,
    '2023-11-18T00:00:00-08:00': 10397,
    '2023-11-19T00:00:00-08:00': 6311,
  },
  {
    '2023-10-20T00:00:00-07:00': 195121,
    '2023-10-21T00:00:00-07:00': 77343,
    '2023-10-22T00:00:00-07:00': 101878,
    '2023-10-23T00:00:00-07:00': 241100,
    '2023-10-24T00:00:00-07:00': 236896,
    '2023-10-25T00:00:00-07:00': 251193,
    '2023-10-26T00:00:00-07:00': 248032,
    '2023-10-27T00:00:00-07:00': 192810,
    '2023-10-28T00:00:00-07:00': 76447,
    '2023-10-29T00:00:00-07:00': 111082,
    '2023-10-30T00:00:00-07:00': 264263,
    '2023-10-31T00:00:00-07:00': 253680,
    '2023-11-01T00:00:00-07:00': 235675,
    '2023-11-02T00:00:00-07:00': 243816,
    '2023-11-03T00:00:00-07:00': 191516,
    '2023-11-04T00:00:00-07:00': 71606,
    '2023-11-05T00:00:00-07:00': 122372,
    '2023-11-06T00:00:00-08:00': 260802,
    '2023-11-07T00:00:00-08:00': 258461,
    '2023-11-08T00:00:00-08:00': 255428,
    '2023-11-09T00:00:00-08:00': 242940,
    '2023-11-10T00:00:00-08:00': 171199,
    '2023-11-11T00:00:00-08:00': 73255,
    '2023-11-12T00:00:00-08:00': 106704,
    '2023-11-13T00:00:00-08:00': 242752,
    '2023-11-14T00:00:00-08:00': 247137,
    '2023-11-15T00:00:00-08:00': 240494,
    '2023-11-16T00:00:00-08:00': 240988,
    '2023-11-17T00:00:00-08:00': 178568,
    '2023-11-18T00:00:00-08:00': 68672,
    '2023-11-19T00:00:00-08:00': 25258,
  },
  {
    '2023-10-20T00:00:00-07:00': 5815,
    '2023-10-21T00:00:00-07:00': 1277,
    '2023-10-22T00:00:00-07:00': 2804,
    '2023-10-23T00:00:00-07:00': 8339,
    '2023-10-24T00:00:00-07:00': 8547,
    '2023-10-25T00:00:00-07:00': 8554,
    '2023-10-26T00:00:00-07:00': 8570,
    '2023-10-27T00:00:00-07:00': 6028,
    '2023-10-28T00:00:00-07:00': 1240,
    '2023-10-29T00:00:00-07:00': 2830,
    '2023-10-30T00:00:00-07:00': 9237,
    '2023-10-31T00:00:00-07:00': 9225,
    '2023-11-01T00:00:00-07:00': 8385,
    '2023-11-02T00:00:00-07:00': 8603,
    '2023-11-03T00:00:00-07:00': 6379,
    '2023-11-04T00:00:00-07:00': 1348,
    '2023-11-05T00:00:00-07:00': 3570,
    '2023-11-06T00:00:00-08:00': 9841,
    '2023-11-07T00:00:00-08:00': 10090,
    '2023-11-08T00:00:00-08:00': 9279,
    '2023-11-09T00:00:00-08:00': 8442,
    '2023-11-10T00:00:00-08:00': 5626,
    '2023-11-11T00:00:00-08:00': 1453,
    '2023-11-12T00:00:00-08:00': 2748,
    '2023-11-13T00:00:00-08:00': 8887,
    '2023-11-14T00:00:00-08:00': 8836,
    '2023-11-15T00:00:00-08:00': 9289,
    '2023-11-16T00:00:00-08:00': 9155,
    '2023-11-17T00:00:00-08:00': 6378,
    '2023-11-18T00:00:00-08:00': 1542,
    '2023-11-19T00:00:00-08:00': 724,
  },
];

const BEHAVIOR = [
  {
    behavior: {
      type: `event`,
      resourceType: `events`,
      search: ``,
      profileType: null,
      filters: [],
      dataGroupId: null,
      dataset: `$mixpanel`,
    },
    measurement: {
      math: `total`,
      property: null,
      cumulative: false,
      perUserAggregation: null,
      rolling: null,
    },
  },
  {
    behavior: {
      type: `event`,
      resourceType: `events`,
      search: ``,
      profileType: null,
      filters: [],
      dataGroupId: null,
      dataset: `$mixpanel`,
    },
    measurement: {
      math: `total`,
      property: null,
      cumulative: false,
      perUserAggregation: null,
      rolling: null,
    },
  },
  {
    behavior: {
      type: `event`,
      resourceType: `events`,
      search: ``,
      profileType: null,
      filters: [],
      dataGroupId: null,
      dataset: `$mixpanel`,
    },
    measurement: {
      math: `total`,
      property: null,
      cumulative: false,
      perUserAggregation: null,
      rolling: null,
    },
  },
  {
    behavior: {
      type: `event`,
      resourceType: `events`,
      search: ``,
      profileType: null,
      filters: [],
      dataGroupId: null,
      dataset: `$mixpanel`,
    },
    measurement: {
      math: `total`,
      property: null,
      cumulative: false,
      perUserAggregation: null,
      rolling: null,
    },
  },
];

const chartProps = (events: string[], cardTitle?: string) => {
  const displayOptions: DisplayOptions = {
    chartType: ChartType.Line,
    plotStyle: ChartPlotStyle.Standard,
    analysis: AnalysisType.Linear,
    value: ValueRepresentationType.Absolute,
    funnelStepsSelectedTableColumns: null,
  };

  return {
    cardTitle,
    chartOptions: {
      type: `line`,
    },

    bookmark: {
      dashboard: {},
      params: {
        sections: {
          cohorts: [],
          filter: [],
          formula: [],
          group: [],
          show: events.map((ev, index) => {
            return {
              ...BEHAVIOR[index],
              name: ev,
            };
          }),
          time: [
            {
              dateRangeType: `in the last`,
              window: {
                unit: `day`,
                value: 30,
              },
              unit: `day`,
            },
          ],
        },
        columnWidths: {
          bar: {},
        },
        displayOptions,
        sorting: {},
      },
      can_view: true,
      allow_staff_override: false,
      is_superadmin: false,
    },
    chartParams: {
      computed_at: `2023-11-19T14:53:28.611942+00:00`,
      headers: [`$event`],
      date_range: {
        from_date: `2023-10-20T00:00:00-07:00`,
        to_date: `2023-11-19T06:53:28.078114-08:00`,
      },
      meta: {
        min_sampling_factor: 1,
        time_period_settings: {
          quarter_start_month: 1,
        },
        report_sections: {
          group: [],
          show: events.map((ev) => ({metric_key: ev})),
        },
      },
      series: events.reduce((acc, ev, index) => {
        acc[ev] = SERIES[index];
        return acc;
      }, {}),
    },
    dataGroups: null,
  };
};

// eslint-disable-next-line react/destructuring-assignment
export const LinePreview = ({events, cardTitle}: {events: string[]; cardTitle?: string}) => {
  //@ts-ignore
  return <CardSnabbdom params={chartProps(events, cardTitle)} />;
};
